// Header.tsx
import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./Header.css";

interface HeaderProps {
  title: string;
  buttons?: {
    label: string;
    onClick?: () => void;
    variant?: string;
  }[];
}

const Header: React.FC<HeaderProps> = ({ title, buttons = [] }) => {
  const getIcon = (label: string) => {
    if (label.includes("Filtra")) {
      return "./assets/filterListAlt.svg";
    } else if (label.includes("Aggiungi")) {
      return "./assets/add.svg";
    } else if (label.includes("Archiviati") || label.includes("In essere")) {
      return "./assets/check.svg";
    }
    return "";
  };

  return (
    <div className="header-container">
      <Row className="align-items-center justify-content-between">
        <Col md={5}>
          <h1 className="header-title">{title}</h1>
        </Col>
        <Col md={7} className="text-end">
          {buttons.map((button, index) => (
            <Button key={index} onClick={button.onClick} variant={button.variant || "primary"} className="ms-2 button">
              <img
                src={getIcon(button.label)}
                alt={button.label}
                className="button-icon"
                style={{ marginRight: "8px" }}
              />
              {button.label}
            </Button>
          ))}
        </Col>
      </Row>
    </div>
  );
};

export default Header;
